import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-language-switcher-popup',
  templateUrl: './language-switcher-popup.component.html',
  styleUrls: ['./language-switcher-popup.component.scss']
})
export class LanguageSwitcherPopupComponent {
  currentLanguage: string;
  availableLanguages = this.languageService.availableLanguages;

  constructor(
    private modalController: ModalController,
    private languageService: LanguageService
  ) {
    this.currentLanguage = this.languageService.getCurrentLanguage();
  }

  async changeLanguage(languageCode: string) {
    await this.languageService.changeLanguage(languageCode);
    this.currentLanguage = languageCode;
    
    // Dismiss modal after language change
    this.dismiss();
  }

  dismiss() {
    this.modalController.dismiss();
  }

  getCurrentLanguageName(): string {
    const lang = this.availableLanguages.find(l => l.code === this.currentLanguage);
    return lang ? lang.name : 'English';
  }

  getCurrentLanguageFlag(): string {
    const lang = this.availableLanguages.find(l => l.code === this.currentLanguage);
    return lang ? lang.flag : '🇺🇸';
  }
} 